<template>
  <div>
    <template v-if="data.length!=0">
      <div>
        <div class="profit_title">
          <h3>總覽</h3>
        </div>
        <div class="profit_contentbox">
          <div class="mm-row">已完成買入{{buy.short_name}} {{tomoney(buy.sum_money)}}，折合港幣金額 HKD {{tomoney(buy.sum_hkd)}}</div>
          <div class="mm-row">已完成賣出{{sell.short_name}} {{tomoney(sell.sum_money)}}，折合港幣金額 HKD {{tomoney(sell.sum_hkd)}}</div>
          <div class="mm-row">已完成港幣金額結餘 HKD {{tomoney(buy.sum_hkd-sell.sum_hkd)}}</div>
        </div>
      </div>
      <div>
        <div class="profit_title">
          <h3>訂單利潤</h3>
        </div>
        <div class="profit_contentbox">
          <div class="mm-row">賣出匯率 {{sell.rate}}</div>
          <div class="mm-row">賣出成本匯率 {{sell.costrate}}</div>
          <div class="mm-row">賣出利潤 {{data.nlms}} = HKD {{tomoney(data.profit_sell)}}</div>
          <div class="mm-row">手續費/佣金利潤 HKD {{tomoney(sxf.sum_hkd||0)}}</div>
          <div class="mm-row">銀行費用 HKD {{tomoney(0)}}</div>
          <div class="mm-row">訂單總利潤 HKD {{tomoney(data.profit_total)}}</div>
        </div>
      </div>
    </template>
    <template v-if="data.length==0">
      <p style="text-align:center">訂單不完整，無法計算利潤</p>
    </template>
  </div>
</template>

<script>
export default {
  props: ['order_id'],
  data () {
    return {
      showpage: false,
      data: [],
      buy: {},
      sell: {},
      sxf: {}

    };
  },
  methods: {
    getdata () {
      this.post('/api/order/profit', {
        order_id: this.order_id
      }).then((res) => {
        if (res != 'nodata') {
          this.buy = res.buy;
          this.sell = res.sell;
          this.sxf = res.sxf;
          this.data = res;
        }

      }).catch((err) => {
        console.log(err)
      })
    }

  },
  created () {
    this.getdata();
  }
};
</script>

<style scoped>
.profit_title h3 {
  color: #333;
  border-bottom: 1px solid #dcdfe6;
  padding: 20px 0;
}
.profit_contentbox {
  padding: 20px 0;
}
.mm-row {
  padding: 10px 0;
}
</style>
